import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

interface QueryTrkEventsPayload {
  skip?: number;
  take?: number;
  search?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  [key: string]: any;
}

interface QueryTrkEventsResponse {
  data: any[];
  total: number;
}

const getTrksApi = async (): Promise<any[]> => {
  const response = await httpClient.get('api/trk/get', {});
  const data = response.data;
  return data?.trks ?? data?.data ?? (Array.isArray(data) ? data : []);
};

const queryTrkEventsApi = async (payload: QueryTrkEventsPayload): Promise<QueryTrkEventsResponse> => {
  const response = await httpClient.post<QueryTrkEventsResponse>('api/trk/query', payload);
  return response.data;
};

const updateTrkEventApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/trk/update', payload);
  return response.data;
};

const updateTrkAssetApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/trk/update-asset', payload);
  return response.data;
};

export const useTrks = () => {
  return useQuery({
    queryKey: ['trks'],
    queryFn: getTrksApi,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useQueryTrkEvents = () => {
  return useMutation({
    mutationFn: queryTrkEventsApi,
  });
};

export const useUpdateTrkEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTrkEventApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trk-events'] });
      queryClient.invalidateQueries({ queryKey: ['location-readings'] });
    },
  });
};

export const useUpdateTrkAsset = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTrkAssetApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trks'] });
      queryClient.invalidateQueries({ queryKey: ['location-details'] });
    },
  });
};
